import YBasePanel from './BasePanel';

export { YBasePanel };
export default YBasePanel;
